const getName = method => {
    if(method === 'all') return 'deposit';
    if(method === 'chime_only') return '<b>Chime</b> deposit';
    if(method === 'cashapp_only') return '<b>CashApp</b> deposit';
    if(method === 'cashapp_chime') return '<b>CashApp</b> or <b>Chime</b> deposit';
    if(method === 'crypto') return '<b>Crypto</b> deposit';
    return 'deposit';
}

const isMethodPassed = (prediction, method) => {
    if(prediction === 'all') return true;
    if(prediction === 'chime_only' && method === 'chime') return true;
    if(prediction === 'cashapp_only' && method === 'cashapp') return true;
    if(prediction === 'cashapp_chime' && ['chime', 'cashapp'].includes(method)) return true;
    if(prediction === 'crypto' && method === 'crypto') return true;
    return false;
}

export default {
    getName,
    isMethodPassed
}